<template>
  <TableLayout :permissions="['business:alibill:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="总交易单数" prop="sumBill">
        <el-input v-model="searchForm.sumBill" placeholder="请输入总交易单数" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款的订单数" prop="sumRefundBill">
        <el-input v-model="searchForm.sumRefundBill" placeholder="请输入退款的订单数" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="应结订单总金额" prop="sumSuccessFee">
        <el-input v-model="searchForm.sumSuccessFee" placeholder="请输入应结订单总金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款总金额" prop="sumRefundFee">
        <el-input v-model="searchForm.sumRefundFee" placeholder="请输入退款总金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="充值券退款总金额" prop="sumCouponRefundFee">
        <el-input v-model="searchForm.sumCouponRefundFee" placeholder="请输入充值券退款总金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="手续费总金额" prop="sumCmmsAmt">
        <el-input v-model="searchForm.sumCmmsAmt" placeholder="请输入手续费总金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="订单总金额" prop="sumTotalFee">
        <el-input v-model="searchForm.sumTotalFee" placeholder="请输入订单总金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="申请退款总金额" prop="sumApplyRefundFee">
        <el-input v-model="searchForm.sumApplyRefundFee" placeholder="请输入申请退款总金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款手续费总金额" prop="sumRefundCmmsAmt">
        <el-input v-model="searchForm.sumRefundCmmsAmt" placeholder="请输入退款手续费总金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="结算金额" prop="total">
        <el-input v-model="searchForm.total" placeholder="请输入结算金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="自行车收入" prop="bikeFee">
        <el-input v-model="searchForm.bikeFee" placeholder="请输入自行车收入" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:alibill:create']">
        <li><el-button type="primary" @click="$refs.operaAliBillWindow.open('新建')" icon="el-icon-plus" v-permissions="['business:alibill:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="" min-width="100px"></el-table-column>
        <el-table-column prop="sumBill" label="总交易单数" min-width="100px"></el-table-column>
        <el-table-column prop="sumRefundBill" label="退款的订单数" min-width="100px"></el-table-column>
        <el-table-column prop="sumSuccessFee" label="应结订单总金额" min-width="100px"></el-table-column>
        <el-table-column prop="sumRefundFee" label="退款总金额" min-width="100px"></el-table-column>
        <el-table-column prop="sumCouponRefundFee" label="充值券退款总金额" min-width="100px"></el-table-column>
        <el-table-column prop="sumCmmsAmt" label="手续费总金额" min-width="100px"></el-table-column>
        <el-table-column prop="sumTotalFee" label="订单总金额" min-width="100px"></el-table-column>
        <el-table-column prop="sumApplyRefundFee" label="申请退款总金额" min-width="100px"></el-table-column>
        <el-table-column prop="sumRefundCmmsAmt" label="退款手续费总金额" min-width="100px"></el-table-column>
        <el-table-column prop="total" label="结算金额" min-width="100px"></el-table-column>
        <el-table-column prop="bikeFee" label="自行车收入" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:alibill:update', 'business:alibill:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaAliBillWindow.open('编辑', row)" icon="el-icon-edit" v-permissions="['business:alibill:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:alibill:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaAliBillWindow ref="operaAliBillWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaAliBillWindow from '@/components/business/OperaAliBillWindow'
export default {
  name: 'AliBill',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaAliBillWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        sumBill: '',
        sumRefundBill: '',
        sumSuccessFee: '',
        sumRefundFee: '',
        sumCouponRefundFee: '',
        sumCmmsAmt: '',
        sumTotalFee: '',
        sumApplyRefundFee: '',
        sumRefundCmmsAmt: '',
        total: '',
        bikeFee: ''
      }
    }
  },
  created () {
    this.config({
      module: '',
      api: '/business/aliBill',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
